import { db } from "@/firebase";
import {
  doc,
  getDoc,
  getDocs,
  collection,
  updateDoc,
} from "firebase/firestore";
import router from "@/router";

const post = {
  state: {
    askChatDrawer: false,
    brand: null,
    category: null,
    carousel: [],
    selectedSlideIndex: null,
    comment: "",
    dialog: false,
    expanded: false,
    instructions: "",
    firstLoad: true,
    link_preview: null,
    media: [],
    html: null,
    getHTMLFn: null, // Function reference from imageBuilder
    getPDFFn: null, // Function reference from imageBuilder
    mode: null,
    post: null,
    urn: null,
    thinking: false,
    auto_variation: true,
    auto_variation_level: "Low",
    last_publish: null,
    preview_dialog: false,
    replace_thumbnail: false,
    recurring: true,
    saving: false,
    schedule_date: null,
    selected_accounts: [],
    show_comment: false,
    status: "draft",
    selected_model: null,
    structure: null,
    selectedTemplate: null,
    selectedTemplateOption: null,
    selectedTemplateData: null,
    template_dialog: false,
    suggested: false,
    idea: {
      draft: "",
      idea: "",
    },
    voice: null,
    variation: null,
    tab: 0,
    variations: [
      {
        text: "",
        type: "main",
        media: null,
        undo: [""],
        redo: [],
      },
    ],
    sheet: false,
    generatingPDF: false,
    statistics: null,
  },
  mutations: {
    setPostExpanded(state, val) {
      state.expanded = val;
    },
    setPostStatistics(state, val) {
      state.statistics = val;
    },
    setPostUrn(state, val) {
      state.urn = val;
    },
    setPostSaving(state, val) {
      state.saving = val;
    },
    setPostHTML(state, val) {
      state.html = val;
    },
    setPostGetHTMLFn(state, fn) {
      state.getHTMLFn = fn;
    },
    setPostGetPDFFn(state, fn) {
      state.getPDFFn = fn;
    },
    setPostMode(state, val) {
      console.log("setPostMode", val);
      state.mode = val;
    },
    setPostCarousel(state, val) {
      if (val && val.length > 0) {
        console.log("setPostCarousel", val);
        state.carousel = val;
        state.mode = "carousel";
      } else if (val.length === 0) {
        state.mode = null;
        state.carousel = [];
      }
    },
    setPostSelectedTemplate(state, val) {
      state.selectedTemplate = val;
    },
    setPostSelectedTemplateOption(state, val) {
      state.selectedTemplateOption = val;
    },
    setPostSelectedTemplateData(state, val) {
      state.selectedTemplateData = val;
    },
    setPostSelectedSlideIndex(state, val) {
      state.selectedSlideIndex = val;
    },
    clearPost(state) {
      state.expanded = false;
      state.category = null;
      state.carousel = [];
      state.selectedSlideIndex = null;
      state.comment = "";
      state.instructions = "";
      state.link_preview = null;
      state.media = [];
      state.mode = null;
      state.post = null;
      state.recurring = true;
      state.schedule_date = null;
      state.selected_accounts = [];
      state.show_comment = false;
      state.auto_variation = true;
      state.auto_variation_level = "Low";
      state.status = "draft";
      state.statistics = null;
      state.structure = null;
      state.idea = {
        draft: "",
        idea: "",
        link: "",
        tags: [],
        timestamp: null,
        title: "",
        url: "",
      };
      state.firstLoad = true;
      state.variations = [
        {
          text: "",
          type: "main",
          media: null,
          undo: [],
          redo: [],
        },
      ];
      state.voice = null;
      state.brand = null;
      state.tab = 0;
      state.variation = null;
      state.auto_variation = true;
      state.auto_variation_level = "Low";
      state.status = "draft";
      state.instructions = "";
      state.urn = null;
    },
    setPostIdea(state, val) {
      state.idea = val;
    },
    setPostAutoVariation(state, val) {
      state.auto_variation = val;
    },
    setPostAutoVariationLevel(state, val) {
      state.auto_variation_level = val;
    },
    setPostStructure(state, val) {
      state.structure = val;
    },
    setPostReplaceThumbnail(state, val) {
      state.replace_thumbnail = val;
    },
    setPostDialog(state, val) {
      state.dialog = val;
    },
    setPostBrand(state, val) {
      state.brand = val;
    },
    setPostVoice(state, val) {
      state.voice = val;
    },
    setPostMedia(state, val) {
      if (state.replace_thumbnail) {
        let replacement = state.media;
        replacement[0].thumbnail = val[0];
        state.media = [];
        state.media = replacement;
        state.replace_thumbnail = false;
      } else {
        state.media = val;
      }
    },
    addPostMedia(state, val) {
      if (state.replace_thumbnail) {
        let replacement = state.media;
        replacement[0].thumbnail = val;
        state.media = [];
        state.media = replacement;
        state.replace_thumbnail = false;
      } else {
        state.media.push(val);
      }
    },
    setPostInstructions(state, val) {
      state.instructions = val;
    },
    setPostCategory(state, val) {
      state.category = val;
    },
    setPostSelectedAccounts(state, val) {
      state.selected_accounts = val;
    },
    setPostComment(state, val) {
      state.comment = val;
    },
    setPostPreviewDialog(state, val) {
      state.preview_dialog = val;
      if (!val) {
        this.commit("clearPost");
      }
    },
    setPostSelectedModel(state, val) {
      state.selected_model = val;
    },
    setPostShowComment(state, val) {
      state.show_comment = val;
    },
    setPostVariations(state, val) {
      state.variations = val;
    },
    setPostVariationText(state, { index, text }) {
      let i = index || state.tab;

      if (state.variations[i]) {
        let x = state.variations[i];
        let chunks = text.split(" ");

        x.text = "";
        for (let i = 0; i <= chunks.length - 1; i++) {
          setTimeout(function () {
            let space = i === 0 ? "" : " ";
            x.text = x.text.concat(space, chunks[i]);
            if (i + 1 === chunks.length) {
              x.timestamp = null;
            }
          }, 10 * i);
        }
      }
    },
    setPostRecurring(state, val) {
      state.recurring = val;
    },
    setPostChat(state, val) {
      state.chat = val;
    },
    setPostLink(state, val) {
      state.link = val;
    },
    setPostLinkPreview(state, val) {
      if (state.media) {
        state.media = null;
      }
      state.link_preview = val;
    },
    setPostUid(state, val) {
      state.post = val;
    },
    setPostScheduleDate(state, val) {
      state.schedule_date = val;
    },
    setPostStatus(state, val) {
      state.status = val;
    },

    setPostAskChatDrawer(state, val) {
      state.askChatDrawer = val;
    },
    setPostTemplateDialog(state, val) {
      state.template_dialog = val;
    },
    setPostTab(state, val) {
      state.tab = val;
    },
    setPostFirstLoad(state, val) {
      state.firstLoad = val;
    },
    setPostSheet(state, val) {
      state.sheet = val;
    },
    setPostSuggested(state, val) {
      state.suggested = val;
    },
    setPostThinking(state, val) {
      state.thinking = val;
    },
    setPostLastPublish(state, val) {
      state.last_publish = val;
    },
    setPostGeneratingPDF(state, val) {
      state.generatingPDF = val;
    },
  },
  actions: {
    startNewPost({ commit, state, rootState }) {
      commit("setPostSheet", true);

      if (state.post) {
        commit("clearPost");
      }

      if (rootState.posts.query.category) {
        const cat = rootState.posts.categories.find(
          (c) => c.uid === rootState.posts.query.category,
        );
        commit("setPostCategory", cat);
      }
    },
    async changeStatus({ commit, rootState }, { status, post }) {
      console.log("change status", status);
      await updateDoc(
        doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "posts",
          post,
        ),
        {
          status: status === "active" ? "draft" : "active",
        },
      );
      commit("changePostStatus", {
        status: status === "active" ? "draft" : "active",
        post: post,
      });
    },
    async loadPost({ commit, dispatch, rootState }, uid) {
      console.log("loadPost: ", uid);
      dispatch("clearPost");
      commit("setPostUid", uid);

      const docRef = doc(
        db,
        "workspaces",
        rootState.users.userProfile.workspace,
        "posts",
        uid,
      );
      const docSnap = await getDoc(docRef);
      let p = docSnap.data();

      if (!p) {
        console.error("Post document not found or has no data:", uid);
        return;
      }

      p.variations = [];
      const messages = await getDocs(
        collection(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "posts",
          uid,
          "variations",
        ),
      );
      console.log("messages.docs.length:", messages.docs.length);
      messages.docs.map((d) => {
        p.variations.push({ ...d.data(), history: [d.data().text] });
      });
      console.log("p.variations: ", p.variations);
      commit("setPostLastPublish", p.last_publish ? p.last_publish : null);
      commit("setPostSelectedAccounts", []);
      commit(
        "setPostCategory",
        p.category
          ? rootState.posts.categories.find((c) => c.uid === p.category)
          : null,
      );
      commit("setPostSelectedAccounts", p.accounts);
      commit("setPostVariations", p.variations);
      commit("setPostComment", p.comment);
      if (p.comment) {
        commit("setPostShowComment", true);
      }
      commit("setPostMedia", p.media);
      commit("setPostRecurring", p.recurring);

      commit("setPostScheduleDate", p.schedule_date ? p.schedule_date : null);
      commit("setPostStatus", p.status);
      commit("setPostSuggested", p.suggested);
      commit("setPostAutoVariation", p.auto_variation);
      commit("setPostAutoVariationLevel", p.auto_variation_level);
      commit("setPostStatistics", p.statistics);
      commit("setPostFirstLoad", false);
      commit("setPostUrn", p.urn);
      console.log("p.urn: ", p.urn);
      if (router.currentRoute.value.path === "/library") {
        commit("setPostSheet", true);
      }
    },
    clearPost({ commit }) {
      commit("clearPost");
      commit("clearAgent");
    },
    async setPost({ commit, rootState }, uid) {
      commit("clearPost");
      commit("setPostUid", uid);

      const docRef = doc(
        db,
        "workspaces",
        rootState.users.userProfile.workspace,
        "posts",
        uid,
      );
      const docSnap = await getDoc(docRef);
      let p = docSnap.data();

      p.variations = [];
      const messages = await getDocs(
        collection(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "posts",
          uid,
          "variations",
        ),
      );
      messages.forEach((d) => {
        p.variations.push(d.data());
      });

      let category = p.category
        ? rootState.posts.categories.find((c) => c.uid === p.category)
        : null;
      commit("setPostCategory", category);

      let accounts = [];
      for (let x in p.accounts) {
        const docSnap = await getDoc(
          doc(
            db,
            "workspaces",
            rootState.users.userProfile.workspace,
            "accounts",
            p.accounts[x],
          ),
        );

        if (docSnap.exists()) {
          accounts.push(docSnap.data());
        } else {
          console.log("No such document!");
        }
      }
      commit("setPostSelectedAccounts", accounts);

      // TO DO: if has link, then update the link preview.
      commit("setPostVariations", p.variations);
      // this.message = p.message;
      commit("setPostComment", p.comment);

      if (p.media) {
        commit("setPostMedia", p.media);
      }

      if (p.link_preview) {
        commit("setPostLinkPreview", p.link_preview);
      }
      commit("setPostRecurring", p.recurring);
      commit("setPostScheduleDate", p.schedule_date);
      commit("setPostStatus", p.status);
      commit("setPostPreviewDialog", true);
    },
  },
  getters: {},
};

export default post;
